<template>
    <div class="parameterInfoBusiness">
        <!-- 业务参数设置 -->
        <el-card class="box-card" v-if="parameterAuth.queryFrom">
            <div slot="header" class="clearfix header">
                <span class="card-header">业务参数设置</span>
            </div>
            <el-row>
                <el-col :span="21">
                    <el-form :label-position="labelPosition" label-width="80px" :model="parameterForm">
                        <el-form-item label="参数类型" style="width: 30%;margin-right: 30px;" class="fl" prop="paraType">
                            <el-input v-model.trim="parameterForm.paraType"></el-input>
                        </el-form-item>
                        <el-form-item label="参数名称" style="width: 30%;margin-right: 30px;" class="fl" prop="paraName">
                            <el-input v-model.trim="parameterForm.paraName"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="3" class="fr">
                    <el-button type="danger" size="small" @click="clearForm()">重置</el-button>
                    <el-button type="success" size="small" @click="queryFrom()" style="margin-left: 0px;">查询</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix header">
                <span class="card-header">参数信息</span>
                <el-button class="fr" size="mini" type="success" @click="handleAddForm()" v-if="parameterAuth.handleAddForm">新增</el-button>
            </div>
            <!--列表-->
            <el-table :data="parameterInfo" highlight-current-row border style="width: 100%;" :header-cell-style="{'text-align':'center'}">
                <el-table-column prop="paraType" label="参数类型" width="320" align="center" sortable></el-table-column>
                <el-table-column prop="paraCode" label="参数编码" width="320" align="center" sortable></el-table-column>
                <el-table-column prop="paraName" label="参数名称" width="320" align="center" sortable></el-table-column>
                <el-table-column label="操作" min-width="150" align="center">
                    <template slot-scope="scope">
                        <el-dropdown  trigger="click">
                            <el-button type="success" size="mini">请选择<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="handleEdit(scope.$index, scope.row)" v-if="parameterAuth.handleEdit">修改</el-dropdown-item>
                                <el-dropdown-item @click.native="handleDel(scope.$index, scope.row)" v-if="parameterAuth.handleDel">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
            <!--修改界面 parameter_number-->
            <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogParameterFormVisible" :close-on-click-modal="false" @close='emptyDialog'>
                <el-form :label-position="labelPosition" :model="editParameterForm" label-width="120px" :rules="editParameterFormRules" ref="editParameterForm">
                    <el-row>
                        <el-form-item label="参数类型：" prop="paraType" style="width: 40%;" class="fl">
                            <el-input v-model.trim="editParameterForm.paraType"></el-input>
                        </el-form-item>
                        <el-form-item label="参数编码：" prop="paraCode" style="width: 55%;" class="fr">
                            <el-input v-model.trim="editParameterForm.paraCode"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="参数数值：" prop="paraValue" style="width: 40%;" class="fl">
                            <el-input v-model.trim="editParameterForm.paraValue"></el-input>
                        </el-form-item>
                        <el-form-item label="参数名称：" prop="paraName" style="width: 55%;" class="fr">
                            <el-input v-model.trim="editParameterForm.paraName"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-form-item label="参数排序：" prop="sort">
                        <el-input v-model.trim="editParameterForm.sort"></el-input>
                    </el-form-item>
                    <el-form-item label="参数所属模块：" prop="belModule">
                        <el-input type="text" v-model.trim="editParameterForm.belModule"></el-input>
                    </el-form-item>
                    <el-form-item label="参数备注:" prop="memo">
                        <el-input type="textarea" v-model.trim="editParameterForm.memo"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="dialogStatus =='create'" type="primary" @click="createData()">添加</el-button>
                    <el-button v-else type="primary" @click="updateData()">保存</el-button>
                    <el-button @click.native="dialogParameterFormVisible=false">取消</el-button>
                    <!-- <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button> -->
                </div>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
    import { selectParameterInfoBusiness,insertBusiness,selectUpdateParameter,parameterEdit,deleteParameter } from '../../api/api'
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'parameterInfoBusiness',
            data () {
                return {
                    //分页
                    pages:{
                        total: 0,
                        page: 1,
                        pageSize: 10,
                    },
                    dialogStatus: "",
                    textMap: {
                        update: "修改参数信息",
                        create: "新增参数信息"
                    },
                    labelPosition:'left',
                    parameterForm: {
                        paraType: '',
                        paraName: '',
                    },
                    dialogStatus: "",
                    dialogParameterFormVisible: false,
                    parameterInfo: [
                        {
                            paraType: '',
                            paraCode: '',
                            paraName: '',
                        },
                    ],
                    //新增and编辑界面数据
                    editParameterForm: {
                        paraType: '',
                        paraCode: '',
                        paraName: '',
                        paraValue: '',
                        belModule: '',
                        memo: '',
                        id: '',
                        sort:''
                    },
                    editParameterFormRules: {
                        paraType: [{ required: true, message: "请输入参数类型", trigger: "blur" }],
                        paraCode: [{ required: true, message: "请输入参数编码", trigger: "blur" }],
                        paraValue: [{ required: true, message: "请输入参数数值", trigger: "blur" }],
                        paraName: [{ required: true, message: "请输入参数名称", trigger: "blur" }],
                    },
                    parameterAuth:{
                        queryFrom:false,
                        handleAddForm:false,  
                        handleEdit:false,  
                        handleDel:false,
                    }
                }
            },
            mounted () {
                this.getData()
                this.parameterAuth.queryFrom = getPermission('/system/parameterInfoBusiness/selectParameterInfoBusiness');
                this.parameterAuth.handleAddForm = getPermission('/system/parameterInfoBusiness/insertBusiness');
                this.parameterAuth.handleEdit = getPermission('/system/parameterInfoBusiness/edit');
                this.parameterAuth.handleDel = getPermission('/system/parameterInfoBusiness/deleteParameter');
                console.log(this.parameterAuth)
            },
            computed: {
              // refundStatus () {
              //   return orderStatus(this.refundOrder.status)
              // }
            },
            methods: {
                //清空dialog
                emptyDialog:function() {
                    this.editParameterForm = {}
                    this.dialogParameterFormVisible = false
                },
                //获取参数信息
                getData() {
                    let para = { 
                        paraName: this.parameterForm.paraName,
                        paraType: this.parameterForm.paraType,
                        pageSize: this.pages.pageSize,
                        startRow: this.pages.page,
                    };
                    selectParameterInfoBusiness(para).then((res) => {
                        if (res.data.status ==100) {
                            this.parameterInfo = res.data.results.list
                            // this.configureInfo = response.data.results.list
                            this.pages.total = res.data.results.total
                            this.pages.pageSize = res.data.results.pageSize
                        }
                    }).catch((error) => {
                        this.$Message.error(error.message);
                    })
                },
                //重置
                clearForm:function () {
                    this.parameterForm={}
                },
                //查询
                queryFrom:function () {
                    // console.log(this.parameterForm)
                    this.getData()
                },
                //跳转到第几页
                handleSizeChange(val) {
                    // console.log(`每页 ${val} 条`);
                    this.pages.pageSize = val
                    // console.log(this.configureInfo.pageSize)
                    this.getData()
                },
                handleCurrentChange(Page) {
                    // console.log(`当前页: ${Page}`);
                    this.pages.page = Page
                    // console.log(this.configureInfo.currentPage)
                    this.getData()
                },
                //显示新增参数信息对话框
                handleAddForm() {
                    this.dialogParameterFormVisible = true
                    this.dialogStatus = "create";
                },
                //确认提交新增信息
                createData: function() {
                    this.$refs.editParameterForm.validate(valid => {
                        if (valid) {
                            this.$confirm("确认提交吗？", "提示", {}).then(() => {
                                let para = {
                                    paraType:this.editParameterForm.paraType,
                                    paraCode:this.editParameterForm.paraCode,
                                    paraName:this.editParameterForm.paraName,
                                    paraValue:this.editParameterForm.paraValue,
                                    belModule:this.editParameterForm.belModule,
                                    memo:this.editParameterForm.memo,
                                    sort:this.editParameterForm.sort
                                }
                                // console.log(para);
                                insertBusiness(para).then(res => {
                                    // console.log(res)
                                    if (res.data.status == 100) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success"
                                        });
                                        this.dialogParameterFormVisible = false
                                        this.getData()
                                        this.$refs.editParameterForm.resetFields();
                                    }else{
                                        this.$message({
                                            message: res.data.message,
                                            type: "error"
                                        });
                                    }
                                });
                            }).catch(e => {
                                // 打印一下错误
                                console.log(e);
                            });
                        }
                    });
                },
                //显示修改界面
                handleEdit: function(index, row) {
                    this.dialogStatus = "update";
                    this.dialogParameterFormVisible = true;
                    //this.editFormVisible = true;
                    this.editParameterForm = Object.assign({}, row);
                    console.log(this.editParameterForm)
                },
                //确认修改信息
                updateData:function() {
                    this.$refs.editParameterForm.validate(valid => {
                        if (valid) {
                            this.$confirm("确认提交吗？", "提示", {}).then(() => {
                                //this.editLoading = true;
                                //NProgress.start();
                                let para = Object.assign({}, this.editParameterForm);
                                parameterEdit(para).then(res => {
                                    //this.editLoading = false;
                                    //NProgress.done();
                                    if (res.status === 200) {
                                        this.$message({
                                            message: "提交成功",
                                            type: "success"
                                        });
                                        this.$refs["editParameterForm"].resetFields();
                                        //this.editFormVisible = false;
                                        this.dialogParameterFormVisible = false;
                                        this.getData();
                                    }
                      
                                });
                            }).catch(e => {
                                // 打印一下错误
                                console.log(e);
                            });
                        }
                    });
                },
                //删除
                handleDel: function(index, row) {
                    this.$confirm("确认删除该记录吗?", "提示", {
                        type: "warning"
                    }).then(() => {
                        let para = { id: row.id };
                        deleteParameter(para).then(res => {
                            if (res.status === 200) {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getData()
                            }else{
                                this.$message({
                                    message: '未成功删除',
                                    type: 'warning'
                                });
                                // this.getDeptLists()
                            }
                        });
                    }).catch(() => {});
                }
            }
        }
</script>
<style lang="scss" scoped>
    .parameterInfoBusiness{
        .box-card{
            margin-bottom: 20px;
            border-radius: 0px;
            .card-header{
                font-size: 14px;
            }
        }
        .toolbar{
            margin: 20px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// parameterInfoBusiness.vue?25ec119d